import { Injectable } from '@angular/core';

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  name: string;
  type?: string;
  permissions?: string[];
}

export interface Menu {
  state: string;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
  permissions?: string[];
}


export const MENUITEMS: Menu[] = [
  {
    state: '/',
    name: 'HOME',
    type: 'link',
    icon: 'explore'
  },
  {
    state: 'customers',
    name: 'CUSTOMERS',
    type: 'link',
    icon: 'account_box',
    permissions: ['CLK-CUST-GET']
  },
  {
    state: 'collects',
    name: 'COLLECT CUSTOMERS',
    type: 'link',
    icon: 'account_box',
    permissions: ['CLK-USCOL-GET']
  },
  {
    state: 'operations',
    name: 'OPERATIONS',
    type: 'link',
    icon: 'payment',
    permissions: ['CLK-OPERATIONS']
  },
  {
    state: 'search-operations',
    name: 'SEARCH TPO OPERATIONS',
    type: 'link',
    icon: 'search',
    permissions: ['CLK-OPERATIONS']
  },
  {
    state: 'commission-accounts',
    name: 'COMMISSION ACCOUNTS',
    type: 'link',
    icon: 'account_balance_wallet',
    permissions: ['CLK-COM-ACC-GET']
  },
  
  {
    state: 'deposit-account-operations',
    name: 'DEPOSIT ACCOUNT',
    type: 'link',
    icon: 'local_atm'
  },
  {
    state: 'reports',
    name: 'REPORTS',
    type: 'sub',
    icon: 'description',
    children: [
      {state: 'operations', name: 'OPERATIONS', permissions: ['CLK-REPORT']},
      {state: 'global-report', name: 'GLOBAL REPORT', permissions: ['CLK-REPORT-GLOBAL']},
      {state: 'commissions', name: 'COMMISSIONS',  permissions: ['CLK-REPORT']},
      {state: 'deposit-account', name: 'DEPOSIT ACCOUNT',  permissions: ['CLK-REPORT']},
      {state: 'organization-report', name: 'ORGANIZATION REPORT', permissions: ['CLK-REPORT']},
      {state: 'client-report', name: 'CUSTOMERS', permissions: ['CLK-REPORT']},
      {state: 'client-collect-report', name: 'CUSTOMERS COLLECT', permissions: ['CLK-REPORT']},
      {state: 'cashout-report', name: 'CASHOUT', permissions: ['CLK-REPORT']},
      {state: 'tpo-report', name: 'THIRDPARTY-REPORT', permissions: ['CLK-THIRDPARTY-REPORT']},
      {state: 'transaction-history',name: 'TRANSACTION HISTORY', permissions: ['CLK-THIRDPARTY-REPORT']},
      {state: 'tpo-report-all', name: 'THIRD PARTY COMMISSION', permissions: ['CLK-THIRDPARTY-COMMISSION']},
      {
        state: 'country-balance',
        name: 'COUNTRY BALANCE',
        type: 'link',
        permissions: ['CLK-COUNTRY-BAL-GET']
      },
      {
        state: 'cash-circulation-report',
        name: 'CURRENCY IN CIRCULATION',
        type: 'link',
        permissions: ['CLK-REPORT']
      },

    ]
  },
 
  {
    state: 'call-centers',
    name: 'CALL CENTERS',
    type: 'link',
    icon: 'call',
    permissions: ['CLK-CACE-GET']
  },
  {
    state: 'agencies',
    name: 'AGENCIES',
    type: 'link',
    icon: 'store_mall_directory',
    permissions: ['CLK-AGEN-GET']
  },
  {
    state: 'organizations',
    name: 'ORGANIZATIONS',
    type: 'link',
    icon: 'business',
    permissions: ['CLK-ORGA-GET']
  },
  {
    state: 'users',
    name: 'USERS',
    type: 'link',
    icon: 'people',
    permissions: ['CLK-USOP-GET']
  },
  {
    state: 'parameters',
    name: 'PARAMETERS',
    type: 'sub',
    icon: 'settings',
    children: [
      {state: 'revenue-sharing', name: 'REVENUE SHARING', permissions: ['CLK-REVENUE_SHARING-GET']},
      {state: 'monetary-areas', name: 'MONETARY AREAS', permissions: ['CLK-MONA-GET']},
      {state: 'countries', name: 'COUNTRIES',  permissions: ['CLK-COUN-GET']},
      {state: 'states', name: 'STATES', permissions: ['CLK-STAT-GET']},
      {state: 'cities', name: 'CITIES', permissions: ['CLK-CITY-GET']},
      {state: 'restrictions', name: 'RESTRICTIONS', permissions: ['CLK-REST-GET']},
      {state: 'promotions',name: 'PROMOTIONS', permissions: ['CLK-REST-GET']},
      {state: 'operation-costs', name: 'OPERATION COSTS', permissions: ['CLK-OPCO-GET']},
      {state: 'others-operation-costs', name: 'OTHERS OPERATION COSTS', permissions: ['CLK-OPCO-GET']},
      {state: 'tpo-api-provider',name: 'TPO API PROVIDER CONFIG', permissions: ['CLK-MONPROV-GET']},
      {state: 'owner-banks', name: 'OWNER BANKS', permissions: ['CLK-APP-OWNER-BANK-GET']},
      {state: 'refunds', name: 'REFUNDS', permissions: ['CLK-OPCO-GET']},
      {state: 'config-operation',name:'CONFIG OPERATION', permissions: ['CLK-ROLE-GET']},
      {state: 'roles', name: 'ROLES', permissions: ['CLK-ROLE-GET']},
      {state: 'platforms', name: 'PLATFORMS', permissions: ['CLK-ROLE-GET']}
    ]
  },
  {
    state: 'logs',
    name: 'LOGS',
    type: 'link',
    icon: 'history',
    permissions: ['CLK-LOG-GET']
  },
  {
    state: 'cashout',
    name: 'CASHOUT',
    type: 'link',
    icon: 'payment',
    permissions: ['CLK-COMMISSION-CASHOUT']
  }
];

@Injectable()
export class MenuItems {
  getAll() {
    return MENUITEMS;
  }
  add(menu: Menu) {
    MENUITEMS.push(menu);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/menu-items/menu-items.ts